import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { WhySection } from './components/WhySection';
import { KitContentsSection } from './components/KitContentsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
export function App() {
  return <main className="w-full min-h-screen bg-[#FDF8F3] overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <WhySection data-id="element-4" />
      <KitContentsSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />

      <footer className="py-8 text-center text-[#3D3229]/40 text-sm bg-[#FDF8F3]" data-id="element-10">
        <p data-id="element-11">
          © {new Date().getFullYear()} Reset Emocional. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}